import { render, staticRenderFns } from "./TaxOverwrite.vue?vue&type=template&id=4942fed9&scoped=true"
import script from "./TaxOverwrite.vue?vue&type=script&lang=ts"
export * from "./TaxOverwrite.vue?vue&type=script&lang=ts"
import style0 from "./TaxOverwrite.vue?vue&type=style&index=0&id=4942fed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942fed9",
  null
  
)

export default component.exports